import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
import FormInputNumber from "../../../../../components/form/FormInputNumber";
import FormSelectOpcSelectServerState from "../../../../../components/form/FormSelectOpcSelectServerState";
// INTERFACES
import {
  GetStatusResponseInterface,
  ServerStateInterface,
} from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentGetStatusResponse({
  data,
  setData,
}: {
  data: GetStatusResponseInterface;
  setData: (newValue: GetStatusResponseInterface) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeValue = (newValue: string | number, variableName: string) => {
    const copy = structuredClone(data);
    if (variableName === "vendor_info" && typeof newValue === "string") {
      copy.status.vendor_info = newValue;
    } else if (variableName === "start_time_low_date_time" && typeof newValue === "number") {
      copy.status.start_time.low_date_time = newValue;
    } else if (variableName === "start_time_high_date_time" && typeof newValue === "number") {
      copy.status.start_time.high_date_time = newValue;
    } else if (variableName === "current_time_low_date_time" && typeof newValue === "number") {
      copy.status.current_time.low_date_time = newValue;
    } else if (variableName === "current_time_high_date_time" && typeof newValue === "number") {
      copy.status.current_time.high_date_time = newValue;
    } else if (variableName === "last_update_time_low_date_time" && typeof newValue === "number") {
      copy.status.last_update_time.low_date_time = newValue;
    } else if (variableName === "last_update_time_high_date_time" && typeof newValue === "number") {
      copy.status.last_update_time.high_date_time = newValue;
    } else if (variableName === "group_count" && typeof newValue === "number") {
      copy.status.group_count = newValue;
    } else if (variableName === "bandwidth" && typeof newValue === "number") {
      copy.status.bandwidth = newValue;
    } else if (variableName === "major_version" && typeof newValue === "number") {
      copy.status.major_version = newValue;
    } else if (variableName === "minor_version" && typeof newValue === "number") {
      copy.status.minor_version = newValue;
    } else if (variableName === "build_number" && typeof newValue === "number") {
      copy.status.build_number = newValue;
    }
    setData(copy);
  };

  const onChangeServerStatus = (newValue: ServerStateInterface) => {
    const copy = structuredClone(data);
    copy.status.server_status = newValue;
    setData(copy);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <FormInputText
        inputValue={data.status.vendor_info}
        inputLabelName={t("general.vendorInfo")}
        inputOnChange={onChangeValue}
        inputVariableName="vendor_info"
        isRequired
        disabledInput={false}
      />
      <FormInputNumber
        inputValue={data.status.start_time.low_date_time}
        inputLabelName={t("general.startTimeLowDateTime")}
        inputOnChange={onChangeValue}
        inputVariableName="start_time_low_date_time"
      />
      <FormInputNumber
        inputValue={data.status.start_time.high_date_time}
        inputLabelName={t("general.startTimeHighDateTime")}
        inputOnChange={onChangeValue}
        inputVariableName="start_time_high_date_time"
      />
      <FormInputNumber
        inputValue={data.status.current_time.low_date_time}
        inputLabelName={t("general.currentTimeLowDateTime")}
        inputOnChange={onChangeValue}
        inputVariableName="current_time_low_date_time"
      />
      <FormInputNumber
        inputValue={data.status.current_time.high_date_time}
        inputLabelName={t("general.currentTimeHighDateTime")}
        inputOnChange={onChangeValue}
        inputVariableName="current_time_high_date_time"
      />
      <FormInputNumber
        inputValue={data.status.last_update_time.low_date_time}
        inputLabelName={t("general.lastUpdateTimeLowDateTime")}
        inputOnChange={onChangeValue}
        inputVariableName="last_update_time_low_date_time"
      />
      <FormInputNumber
        inputValue={data.status.last_update_time.high_date_time}
        inputLabelName={t("general.lastUpdateTimeHighDateTime")}
        inputOnChange={onChangeValue}
        inputVariableName="last_update_time_high_date_time"
      />
      <FormInputNumber
        inputValue={data.status.group_count}
        inputLabelName={t("general.groupCount")}
        inputOnChange={onChangeValue}
        inputVariableName="group_count"
      />
      <FormInputNumber
        inputValue={data.status.bandwidth}
        inputLabelName={t("general.bandwidth")}
        inputOnChange={onChangeValue}
        inputVariableName="bandwidth"
      />
      <FormInputNumber
        inputValue={data.status.major_version}
        inputLabelName={t("general.majorVersion")}
        inputOnChange={onChangeValue}
        inputVariableName="major_version"
      />
      <FormInputNumber
        inputValue={data.status.minor_version}
        inputLabelName={t("general.minorVersion")}
        inputOnChange={onChangeValue}
        inputVariableName="minor_version"
      />
      <FormInputNumber
        inputValue={data.status.build_number}
        inputLabelName={t("general.buildNumber")}
        inputOnChange={onChangeValue}
        inputVariableName="build_number"
      />
      <FormSelectOpcSelectServerState
        inputValue={data.status.server_status}
        inputOnChange={onChangeServerStatus}
        disabledInput={false}
      />
    </div>
  );
}
